import React, { Component } from 'react';

import {
    Spin,
    Card,
    Statistic,
    Button,
} from 'antd';

import { RedoOutlined, RobotOutlined } from '@ant-design/icons';

class KeyInvalid extends Component {
    render() {
        const { resetApiKey } = this.props;
        return (
            <div style={{ width: '100%', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div><RobotOutlined style={{ fontSize: 34 }} /></div>
                <div style={{ marginTop: 10, marginBottom: 15, textAlign: 'center' }}>Your API Key is invalid<br /> Please reconnect or reach out to support if the error persists.</div>
                <Button icon={<RedoOutlined />} onClick={resetApiKey}>Reconnect</Button>
            </div>
        );
    }
}

export default KeyInvalid;